import { rgba } from "polished";
import styled from "styled-components";
import { FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
export const LastNews = styled.div.withConfig({
    displayName: "styled__LastNews",
    componentId: "sc-c4f7515d-0"
})`
	background-color: ${(props)=>rgba(props.theme.colors.primary.base, 0.08)};
	border-bottom: 1px solid ${({ theme  })=>theme.colors.grays.light};
	padding-bottom: 15px;

	ul {
		padding-bottom: 16px;
		margin: 0 12px;

		li {
			max-width: 330px;
			min-width: 330px;
			padding-right: 50px;
		}
	}
`;
export const Title = styled.h2.withConfig({
    displayName: "styled__Title",
    componentId: "sc-c4f7515d-1"
})`
	color: ${({ theme  })=>theme.colors.primary.base};
	${FontMixin({
    size: 'base',
    weight: 'semiBold'
})}
	padding: 20px 0 10px 20px;
	margin: 0 12px;
	border-bottom: 1px solid ${(props)=>rgba(props.theme.colors.primary.base, 0.32)};
	margin-bottom: 12px;
	text-transform: uppercase;
	position: relative;

	::after {
		content: '';
		background-color: ${({ theme  })=>theme.colors.primary.base};
		border-radius: 50%;
		width: 10px;
		height: 10px;
		position: absolute;
		left: 0;
		top: 50%;
	}
`;
export const Link = styled.a.withConfig({
    displayName: "styled__Link",
    componentId: "sc-c4f7515d-2"
})``;
export const DateNew = styled.span.withConfig({
    displayName: "styled__DateNew",
    componentId: "sc-c4f7515d-3"
})`
	color: ${({ theme  })=>theme.colors.grays.dark};
	${FontMixin({
    size: 'medium',
    weight: 'light',
    height: 'base'
})}
	text-transform: uppercase;
`;
export const Text = styled.p.withConfig({
    displayName: "styled__Text",
    componentId: "sc-c4f7515d-4"
})`
	color: ${({ theme  })=>theme.colors.grays.darker};
	${FontMixin({
    size: 'medium',
    weight: 'regular',
    height: 'base'
})}
`;

//# sourceMappingURL=styled.js.map